<template>
  <el-dialog
    title="国际退款办理"
    :visible.sync="isShow"
    destroy-on-close
    width="900px"
    append-to-body
    @close="closeDialog"
  >
    <div v-loading="loading">
      <el-descriptions v-if="apply && apply.refundNum" :column="2" border size="small" title="主单信息">
        <el-descriptions-item label="退款申请单号">{{ apply.refundNum }}</el-descriptions-item>
        <el-descriptions-item label="收款编号">{{ apply.telegraphicTransferNum }}</el-descriptions-item>
        <el-descriptions-item label="业务实体">{{ apply.businessEntity }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ apply.state }}</el-descriptions-item>
        <el-descriptions-item label="当前节点">{{ apply.currentNodeName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="退款金额">{{ apply.returnAmount }} {{ apply.currency }}</el-descriptions-item>
        <el-descriptions-item label="折算USD">{{ apply.returnAmountUsd }}</el-descriptions-item>
        <el-descriptions-item label="收款单位">{{ apply.payee }}</el-descriptions-item>
        <el-descriptions-item label="银行账号">{{ apply.bankAccount }}</el-descriptions-item>
        <el-descriptions-item label="开户行">{{ apply.openBank }}</el-descriptions-item>
        <el-descriptions-item label="联行号">{{ apply.customerBankNo }}</el-descriptions-item>
        <el-descriptions-item label="SWIFT">{{ apply.swiftCode }}</el-descriptions-item>
        <el-descriptions-item label="申请人">{{ apply.applicationName }}</el-descriptions-item>
        <el-descriptions-item label="申请时间" :span="2">{{ apply.applicationTime }}</el-descriptions-item>
        <el-descriptions-item label="退款理由" :span="2">
          <div class="reason-content">{{ apply.reason }}</div>
        </el-descriptions-item>
      </el-descriptions>

      <div style="margin-top: 16px;font-weight: 600;">审批流水</div>
      <el-table :data="records" border size="mini" height="200" style="width: 100%;margin-top: 8px;">
        <el-table-column prop="approvalTime" label="时间" min-width="140" />
        <el-table-column prop="nodeName" label="节点" />
        <el-table-column prop="approver" label="操作人" />
        <el-table-column prop="approvalResult" label="结果" width="80" />
        <el-table-column prop="approvalOpinion" label="意见" min-width="120" />
      </el-table>

      <el-form :model="formData" label-width="80px" class="form-wrap">
        <el-form-item prop="transferOpinion" label="审批意见" required>
          <el-input
            v-model="formData.transferOpinion"
            :autosize="{ minRows: 4, maxRows: 6}"
            type="textarea"
            placeholder="请输入审批意见"
            maxlength="4000"
            show-word-limit
            style="width: 100%;"
          />
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="mini" :loading="submitting" @click="submitData('同意')">
        同意
      </el-button>
      <el-button type="default" size="mini" :loading="submitting" @click="confirmReject">
        驳回
      </el-button>
      <el-button type="default" size="mini" :disabled="submitting" @click="closeDialog">
        取消
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { overseasRefundDetail, overseasRefundTransact } from '@/API';

export default {
  name: 'OverseasRefundTransactDialog',
  data () {
    return {
      isShow: false,
      loading: false,
      submitting: false,
      apply: {},
      records: [],
      formData: {
        overseasRefundId: null,
        nodeId: null,
        transferOpinion: ''
      }
    };
  },
  methods: {
    open (overseasRefundId, nodeId) {
      this.formData.overseasRefundId = overseasRefundId;
      this.formData.nodeId = nodeId;
      this.formData.transferOpinion = '';
      this.isShow = true;
      this.loadDetail(overseasRefundId);
    },
    closeDialog () {
      this.isShow = false;
      this.apply = {};
      this.records = [];
      this.formData = { overseasRefundId: null, nodeId: null, transferOpinion: '' };
    },
    loadDetail (id) {
      this.loading = true;
      overseasRefundDetail({ overseasRefundId: id })
        .then(res => {
          const data = (res && res.data && res.data.data) || {};
          this.apply = data.apply || {};
          this.records = data.records || [];
          if (!this.formData.nodeId && data.currentTodoNodeId) {
            this.formData.nodeId = data.currentTodoNodeId;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    confirmReject () {
      if (!String(this.formData.transferOpinion || '').trim()) {
        return this.$message.warning('请输入审批意见！');
      }
      this.$confirm('确定驳回？', '提示', { type: 'warning' })
        .then(() => {
          this.submitData('驳回');
        })
        .catch(() => {});
    },
    submitData (type) {
      if (!String(this.formData.transferOpinion || '').trim()) {
        return this.$message.warning('请输入审批意见！');
      }
      if (!this.formData.nodeId) {
        return this.$message.warning('缺少待办节点，无法办理');
      }
      this.submitting = true;
      overseasRefundTransact({
        overseasRefundId: this.formData.overseasRefundId,
        nodeId: this.formData.nodeId,
        transferOpinion: this.formData.transferOpinion,
        type
      })
        .then((res) => {
          // axios 拦截器业务失败仍会 resolve 并弹出错误；此处必须判 status，避免再弹「办理成功」
          // R-021：ERP 可退不足时拦截器已提示当前审批人；不关弹窗、节点仍待办
          const status = res && res.data && res.data.status;
          if (status === '200') {
            this.closeDialog();
            this.$emit('on-ok');
            this.$message.success('办理成功');
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.form-wrap {
  margin-top: 14px;
}
.reason-content {
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 22px;
  max-height: 160px;
  overflow-y: auto;
}
</style>
